import { environment } from '../environments/environment';
import { LoaderService } from './services/loader/loader.service';
import { CampaignService } from './services/campaign/campaign.service';
import { AppConfigService } from './services/app-config/app-config.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CaptchaComponent } from './captcha/captcha.component';

import { BezeqLoggerModule } from 'bezeq-logger';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ResetEntryRedirectComponent } from './pages/reset-entry-redirect/reset-entry-redirect.component';
// import { BundleSalesLayoutComponent } from './layouts/bundle-sales-layout/bundle-sales-layout.component';
// import { BundleSalesLayoutModule } from './layouts/bundle-sales-layout/bundle-sales-layout.module';
// import { LayoutHeaderComponent } from './components/layout-header/layout-header.component';

// import { IdentityNumberComponent } from './shared-pages-components/identityNumber/identityNumber.component';
// import { PersonalDetailsComponent } from './screen-steps/personal-details/personal-details.component';
// import { ChooseDeviceComponent } from './screen-steps/choose-device/choose-device.component';
// import { InstallationAddressComponent } from './screen-steps/installation-address/installation-address.component';
// import { InstallationTimeComponent } from './screen-steps/installation-time/installation-time.component';
import { OrderSummaryComponent } from './components/order-summary/order-summary.component';
import { CampaignResponse } from './models/Campaign/CampaignResponse.model';
// import { ModalMessageComponent } from './components/modal-message/modal-message.component';
// import { TestPageComponent } from './screen-steps/test-page/test-page.component';
// import { MessageScreenComponent } from './screen-steps/message-screen/message-screen.component';
// import { DevNavigationComponent } from './layouts/dev-navigation/dev-navigation.component';
// import { ChangeIdentityStripComponent } from './components/change-identity-strip/change-identity-strip.component';

// import { SelectPhonenumberListComponent } from './shared-pages-components/select-phonenumber-list/select-phonenumber-list.component';
// import { SelectPhonenumberInputComponent } from './shared-pages-components/select-phonenumber-input/select-phonenumber-input.component';

// import { IspQuestionStripComponent } from './components/isp-question-strip/isp-question-strip.component';
// import { IspQuestionScreenComponent } from './screen-steps/isp-question-screen/isp-question-screen.component';
// import { TimeWindowSelectComponent } from './components/time-window-select/time-window-select.component';
// import { DeliverySelectComponent } from './screen-steps/delivery-select/delivery-select.component';
// import { AddressFormComponent } from './components/address-form/address-form.component';
// import { MovingOffersComponent } from './shared-pages-components/moving-offers/moving-offers.component';
// import { PublishPhoneNumber } from './shared/components/publish-phoneNumber/publish-phoneNumber.component';
// import { MovingInstallationAddress } from './shared-pages-components/Moving-installation-Address/Moving-Installation-Address.component';
// import { MovingInstallationCordination } from './shared-pages-components/moving-installation-coordination/moving-installation-coordination.component';
// import { Movingselectphonenumber } from './shared-pages-components/moving-select-phonenumber/moving-select-phonenumber.component';
// import { AddressFormModalComponent } from './components/address-form-modal/address-form-modal.component';
import { registerLocaleData } from '@angular/common';
import localeHe from '@angular/common/locales/he';
// import { PaymentSuccessComponent } from './components/payment-success/payment-success.component';
// import { BranchListComponent } from './components/branch-list/branch-list.component';
// import { BranchDetailsComponent } from './components/branch-details/branch-details.component';
// import { BaranchDetailsModalComponent } from './components/baranch-details-modal/baranch-details-modal.component';
// import { ThankyouBoxComponent } from './components/thankyou-box/thankyou-box.component';
// import { OrderNumberBoxComponent } from './components/order-number-box/order-number-box.component';
// import { MoreDetailsPaymentsComponent } from './components/more-details-payments/more-details-payments.component';
// import { BezeqSiteHeaderModule } from '../app/shared/components/bezeq-site-header/bezeq-site-header.module';
// import { VerifyDetailsComponent } from './shared-pages-components/verify-details/verify-details.component';
// import { ResetPasswordComponent } from './shared-pages-components/reset-password/reset-password.component';
// import { ResetPasswordCheckComponent } from './shared-pages-components/reset-password-check/reset-password-check.component';
// import { IdPhoneIdentificationComponent } from './shared-pages-components/id-phone-identification/id-phone-identification.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import { ExampleHeader } from './shared-pages-components/example-header/example-header.component';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { A11yModule } from '@angular/cdk/a11y';
import { PopUpLoaderModule } from './shared/components/pop-up-loader/pop-up-loader.module';
import { LoaderModule } from './shared/components/loader/loader.module';

registerLocaleData(localeHe);

export function initializeAppConfig(appConfigService: AppConfigService): () => Promise<any> {
  return (): Promise<any> => {
    return appConfigService.loadAppConfig().toPromise();
  };
}

export function initializeCampaign(campaignService: CampaignService): () => Promise<CampaignResponse> {
  return (): Promise<CampaignResponse> => {
    const url = new URL(window.location.href);
    const bannerID = url.searchParams.get('bannerID');
    if (bannerID) {
      const req = {
        Banner: bannerID
      };
      return campaignService.LoadCampaign(req).toPromise();
    } else {
      return new Promise((resolve, reject) => resolve(null));
    }
  };
}

(window as any).callOutJsProgress = value => {
  // TODO: use service instead of global context
  window['progressDiv'] = document.getElementsByClassName('mat-progress-bar-primary');
  if (window['progressDiv'].length > 0) {
    window['progressDiv'][0].style.width = value + '%';
  } else if (value == null) {
    window['progressDiv'] = window['progressDiv'] || [];
    if (window['progressDiv'][0]?.style) {
      window['progressDiv'][0].style.width = 3 + '%';
    }
  }
};

// export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
//   parse(url: string): UrlTree {
//       // Optional Step: Do some stuff with the url if needed.
//       // If you lower it in the optional step
//       // you don't need to use "toLowerCase"
//       // when you pass it down to the next function
//       return super.parse(url.toLowerCase());
//   }
// }

@NgModule({
  declarations: [
    AppComponent,
    ResetEntryRedirectComponent,
    // BundleSalesLayoutComponent,
    // LayoutHeaderComponent,
    // PersonalDetailsComponent,
    // ChooseDeviceComponent,
    // InstallationAddressComponent,
    // InstallationTimeComponent,
    OrderSummaryComponent,
    // ModalMessageComponent,
    // TestPageComponent,
    // MessageScreenComponent,
    // DevNavigationComponent,
    // IdentityNumberComponent,
    // ChangeIdentityStripComponent,
    // SelectPhonenumberListComponent,
    // SelectPhonenumberInputComponent,
    // ResetPasswordComponent,
    // ResetPasswordCheckComponent,
    // IspQuestionStripComponent,
    // IspQuestionScreenComponent,
    // TimeWindowSelectComponent,
    // DeliverySelectComponent,
    // AddressFormComponent,
    // AddressFormModalComponent,
    // PaymentSuccessComponent,
    // BranchListComponent,
    // BranchDetailsComponent,
    // BaranchDetailsModalComponent,
    // ThankyouBoxComponent,
    // OrderNumberBoxComponent,
    // MoreDetailsPaymentsComponent,
    CaptchaComponent,
    // IdPhoneIdentificationComponent,
    // MovingInstallationAddress,
    // MovingInstallationCordination,
    // Movingselectphonenumber,
    // PublishPhoneNumber,
    // MovingOffersComponent,
    // ExampleHeader
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    A11yModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    AppRoutingModule,
    NgxCaptchaModule,
    // BezeqSiteHeaderModule,
    HttpClientModule,
    BezeqLoggerModule.init({
      appId: environment.LogAppID,
      loggerUrl: environment.loggerApiUrl
    }),
    LoaderModule,
    PopUpLoaderModule
    // AgmCoreModule.forRoot({
    //   apiKey: ''
    // }),
    // BundleSalesLayoutModule
  ],
  exports: [],
  providers: [
    LoaderService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppConfig,
      deps: [AppConfigService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCampaign,
      deps: [CampaignService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'he' }
    // {
    //     provide: UrlSerializer,
    //     useClass: LowerCaseUrlSerializer
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
